<template>
  <div class="animate-in px-8 py-7">
    <slot />
  </div>
</template>
